module.exports = __webpack_public_path__ + "img/icon-check@2x.c37fd71c.png";